import React from "react";
import { useTranslation } from "react-i18next";

export function H4 (props) {
    const { i18n } = useTranslation();
    return <h4>{i18n.t(props.label)}</h4>;
}
